import { render } from "./lotteryResultDialog.vue?vue&type=template&id=b5264632&scoped=true"
import script from "./lotteryResultDialog.vue?vue&type=script&lang=js"
export * from "./lotteryResultDialog.vue?vue&type=script&lang=js"

import "./lotteryResultDialog.vue?vue&type=style&index=0&id=b5264632&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5264632"]])

export default __exports__